export class PositionSelector{
    history:number[] = []
    maxHistory:number
    constructor(maxSelectionHistory:number = 4){
        this.maxHistory = maxSelectionHistory
        this.history = [Math.floor(Math.random() * 7)]
    }
    addToHistory = (position:number) => {
        if(this.history.includes(position)){return}
        this.history.push(position)
        const surplus:number = this.history.length - this.maxHistory
        if(surplus > 0){
            this.history.splice(0, surplus)
        }
    }
    getRandomPosition(currentSelectedPosition:number = 0, excludeRoot:boolean = false){
        if(currentSelectedPosition < 0){
            return this.history[this.history.length - 1]
        }
        let positions:number[] = (!excludeRoot) ? [0,1,2,3,4,5,6] : [1,2,3,4,5,6]
        this.history.forEach((position:number)=>{
            const index:number = positions.indexOf(position)
            if(index > -1){positions.splice(index,1)}
        })
        const randomIndex:number = Math.floor(Math.random() * positions.length)
        const position:number = positions[randomIndex]
        this.addToHistory(position)
        return position
    }
}